var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('h3',{staticClass:"mb-4"},[_vm._v(" DocumentV2 editor ")]),_c('div',{staticStyle:{"border":"1px dotted gray"}},[_c('DocumentEditor',{attrs:{"document":_vm.document}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }